module.exports = __webpack_public_path__ + "img/card2.21b0b851.jpg";